import Component from '@glimmer/component';

export default class CAtomComponent extends Component {
  <template>
    <span class="c-atom" ...attributes>{{yield}}</span>
  </template>
}
